import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useQuery } from 'data-fetching-client';
import unescapedText from 'I18n/utils/unescapedText';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
// @ts-expect-error module is untyped
import localeComparator from 'I18n/utils/localeComparator';
import FilterToggleGroup from 'ecosystem-marketplace-core/filters/components/filterToggleGroup'; // @ts-expect-error module is untyped

import LoadingWrapper from 'ecosystem-marketplace-core/components/LoadingWrapper';
import * as RequestStates from 'ecosystem-marketplace-core/constants/RequestState';
import * as ThemeQueryField from '../../../constants/ThemeQueryField';
import { GET_SEARCH_TAGS } from '../../../queries/searchTagQuery';

const LoadingComponent = () => /*#__PURE__*/_jsx(UILoadingSpinner, {
  size: "extra-small"
});

const SearchTagFilter = ({
  disabled,
  onChange,
  scrollable = true,
  value
}) => {
  const {
    loading,
    error,
    data,
    previousData
  } = useQuery(GET_SEARCH_TAGS);
  const searchTagsOptions = useMemo(() => {
    const searchTagsData = data || previousData;

    if (!searchTagsData) {
      return [];
    }

    const {
      searchTags: {
        tags
      }
    } = searchTagsData;
    return tags.map(item => ({
      text: item,
      value: item
    })).sort((a, b) => localeComparator(a.text, b.text));
  }, [data, previousData]);
  const searchTagsRequestState = useMemo(() => {
    if (loading) {
      return RequestStates.PENDING;
    }

    if (error) {
      return RequestStates.FAILED;
    }

    if (!data && !previousData) {
      return RequestStates.UNINITIALIZED;
    }

    return RequestStates.SUCCEEDED;
  }, [data, error, loading, previousData]);
  return /*#__PURE__*/_jsx(LoadingWrapper, {
    LoadingComponent: LoadingComponent,
    requestStatus: searchTagsRequestState,
    children: /*#__PURE__*/_jsx(FilterToggleGroup, {
      ariaLabel: unescapedText('marketplace-assets-ui.themes.filters.searchTags.title'),
      disabled: disabled,
      multi: true,
      name: ThemeQueryField.TAGS,
      onChange: onChange,
      options: searchTagsOptions,
      scrollable: scrollable,
      searchable: true,
      value: value,
      virtualized: scrollable
    })
  });
};

export default SearchTagFilter;